module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-window-view-slider/assets/slider-image-01.f78ebb78c285574d0242805ddc706d8a.webp";